// extracted by mini-css-extract-plugin
module.exports = {"selectedIcon":"style-module_selectedIcon__jlhfQiuAQ0RDJWOsdl_R"};